export default __webpack_public_path__ + "static/media/userdiscussions.4df0771d.svg";